'use strict';


export default function() {
	return function filter(dateStr, seconds) {
		return new Date(new Date(dateStr).getTime() + seconds*1000);
	}
}
